import { render } from "./ZioMed.vue?vue&type=template&id=8c6e9198&scoped=true"
import script from "./ZioMed.vue?vue&type=script&lang=js"
export * from "./ZioMed.vue?vue&type=script&lang=js"

import "./ZioMed.vue?vue&type=style&index=0&id=8c6e9198&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c6e9198"]])

export default __exports__